import React from 'react'
import { CameraIcon } from '@heroicons/react/24/outline'
import FadeInImage from '../../FadeInImage'

// Generic placeholder used when a gallery has no usable image at all
// (empty images array, or none of them decoded a valid URL).
const FALLBACK_IMAGE = '/storage/events/balade-a-chameau-agafay-events-partner-396-2021-11-28.jpeg';

/**
 * Gallery card — same visual language as Home > Categories' CategoryCard
 * (rounded-2xl image tile, gradient overlay, title pinned bottom-left).
 *
 * Crash fix: the old code did
 *   props.data.images.find(i => i.default === '1').image
 * which throws when no image has default === '1' (wrong type — the API
 * actually returns a number 1/0 — unset flag, or an empty images array).
 * We now fall back to the first image, then a generic placeholder, and
 * never call .image on undefined.
 */
const Item = (props) => {
    const images = props.data?.images || [];
    const image =
        images.find((i) => i.default === '1' || i.default === 1)?.image ||
        images[0]?.image ||
        FALLBACK_IMAGE;
    const photosCount = props.data?.images_count ?? images.length;

    return (
        <div className="group relative h-[220px] w-full overflow-hidden rounded-2xl shadow-card transition-all duration-300 ease-out-quint hover:-translate-y-1 hover:shadow-elevated sm:h-[280px]">
            <div className="absolute inset-0 overflow-hidden">
                <div className="h-full w-full transition-transform duration-[900ms] ease-out-quint group-hover:scale-[1.08]">
                    <FadeInImage src={image} alt={props.data?.title} className="h-full w-full object-cover" />
                </div>
            </div>

            {/* gradient overlay for legibility */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/15 to-transparent" />

            {/* photo count chip */}
            {photosCount ? (
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-white/95 px-2.5 py-1 text-[11px] font-semibold text-brand-900 shadow-card backdrop-blur rtl:right-auto rtl:left-3">
                    <CameraIcon className="h-3 w-3" />
                    {photosCount}
                </span>
            ) : null}

            {/* title pinned bottom */}
            <div className="absolute inset-x-0 bottom-0 p-3.5 sm:p-4">
                <h2 className="line-clamp-2 font-display text-base font-semibold leading-tight text-white drop-shadow-sm sm:text-lg">
                    {props.data?.title}
                </h2>
            </div>
        </div>
    )
}
export default Item
